import { create } from 'apisauce';

import { serializer, deserializer } from './serializer';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const STATUS_CODES = {
  unauthorized: 401,
  notFound: 404
};

const api = create({
  baseURL: BASE_URL,
  timeout: 15000
});

export const setApiLanguage = (lang: string) => {
  api.setHeader('Accept-Language', lang);
};

setApiLanguage(localStorage.getItem('language') || 'es');

// eslint-disable-next-line no-unused-vars, prettier/prettier
export const apiSetup = dispatch => {
  // A 401 means the session is no longer valid (token expired/revoked).
  // Silently revert to the public (published-only) experience: clear the token
  // and drop the Authorization header so subsequent requests are anonymous.
  // Lazy require avoids the api <-> AuthServices circular import.
  api.addMonitor(response => {
    if (response.status === STATUS_CODES.unauthorized) {
      // eslint-disable-next-line global-require
      const { removeCurrentUser } = require('../services/AuthServices');
      removeCurrentUser();
    }
  });

  api.addResponseTransform(response => {
    if (response.data) {
      response.data = deserializer.serialize(response.data);
    }
  });

  api.addRequestTransform(request => {
    if (request.data) {
      request.data = serializer.serialize(request.data);
    }
  });
};

export default api;
